import { render, staticRenderFns } from "./v-page-container.vue?vue&type=template&id=1a5fc1ac&scoped=true&"
import script from "./v-page-container.vue?vue&type=script&lang=js&"
export * from "./v-page-container.vue?vue&type=script&lang=js&"
import style0 from "./v-page-container.vue?vue&type=style&index=0&id=1a5fc1ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5fc1ac",
  null
  
)

export default component.exports